import Vue from 'vue'

export function login(data = {}) {
    return Vue.axios({
        url: '/login/login.do',
        method: 'post',
        data: qs.stringify(data)
    })
}

/**
 * 获取用户信息
 */
export function getInfo() {
    return Vue.dyform.dispose('permission', 'loadUserResource', {})
}

export function logout() {
    return Vue.axios({
        url: '/login/logout.do',
        method: 'post'
    })
}